import { View, Text, ViewStyle } from "react-native";
import { Dropdown } from "../../components";
import { Control, Controller } from "react-hook-form";
import { JobPreferenceField, JobPreferencesFormData } from "./types";

interface MinimumCompensationProps {
  control: Control<JobPreferencesFormData>;
  minimumCompensation: JobPreferenceField[];
  style?: ViewStyle; // Required for space-y-1 in root component.
}

const MinimumCompensation = ({ control, minimumCompensation, style }: MinimumCompensationProps) => (
  <View className="bg-white px-6 py-8" {...{ style }}>
    <Text className="text-large-normal text-ink-darkest font-700 mb-6">
      What is your minimum total compensation requirement?
    </Text>
    <View className="mb-4">
      <Controller
        name="minimumCompensation"
        control={control}
        defaultValue={minimumCompensation[0]?.value}
        render={({ field: { onChange, value } }) => (
          <Dropdown
            {...{
              value,
              setValue: onChange,
              list: minimumCompensation.map(({ label, value }) => ({ label, value })),
            }}
          />
        )}
      />
    </View>
  </View>
);

export default MinimumCompensation;
